import React from "react";
import { Link } from "react-router-dom";
import serviceImg1 from "../../images/services/service_image_6.jpg";
import serviceImg2 from "../../images/services/service_image_7.jpg";
import serviceImg3 from "../../images/services/service_details_image_3.webp";
import serviceImg4 from "../../images/services/service_details_image_4.webp";
import serviceImg5 from "../../images/services/service_image_8.jpg";
import serviceImg6 from "../../images/services/service_image_9.jpg";

const TeamSection = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  const sectionStyle = {
    padding: "60px 0",
    textAlign: "center",
    backgroundColor: "#f8f9fa",
  };

  const serviceGridStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "20px",
  };

  const serviceCardStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    maxWidth: "380px",
    background: "white",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease-in-out",
    cursor: "pointer",
  };

  const imageStyle = {
    width: "100%",
    height: "180px",
    objectFit: "cover",
    borderRadius: "8px",
  };

  const services = [
    {
      title: "Custom Software Development",
      image: serviceImg1,
      description:
        "Develop tailor-made software solutions to meet unique business needs and enhance efficiency.",
    },
    {
      title: "Web & Mobile App Development",
      image: serviceImg2,
      description:
        "Create high-performance, responsive websites and mobile applications for seamless user experiences.",
    },
    {
      title: "Cloud Solutions & DevOps",
      image: serviceImg3,
      description:
        "Deploy, manage, and optimize cloud-based infrastructure with automated DevOps solutions.",
    },
    {
      title: "AI, Data Science & Big Data Solutions",
      image: serviceImg4,
      description:
        "Utilize AI, machine learning, and big data analytics to drive smarter business decisions.",
    },
    {
      title: "E-commerce Solutions",
      image: serviceImg5,
      description:
        "Develop secure and scalable e-commerce platforms to boost online sales and customer engagement.",
    },
    {
      title: "UI/UX Design & Branding",
      image: serviceImg6,
      description:
        "Design intuitive user interfaces and brand identities to create impactful digital experiences.",
    },
  ];

  return (
    <section style={sectionStyle}>
      <div className="container">
        <div className="heading_block text-center">
          <div className="heading_focus_text">
            <span className="badge bg-secondary text-white">Our Services</span>
            What We Offer 🚀
          </div>
          <h2 className="heading_text mb-0">
            Transforming Businesses with Cutting-Edge Solutions
          </h2>
        </div>

        {/* Services Grid */}
        <div style={serviceGridStyle}>
          {services.map((service, index) => (
            <div key={index} style={serviceCardStyle}>
              <img src={service.image} alt={service.title} style={imageStyle} />
              <h4 className="mt-5">{service.title}</h4>
              <p>{service.description}</p>
            </div>
          ))}
        </div>

        {/* Services List */}

        {/* Call to Action */}
        <div className="col-xl-3 col-lg-3 col-5  d-flex justify-content-center w-100 mt-3">
          <ul className="header_btns_group unordered_list">
            <li>
              <Link
                onClick={ClickHandler}
                className="btn btn-primary"
                to="/contact"
              >
                <span className="btn_label" data-text="Get Started">
                  Get Started
                </span>
                <span className="btn_icon">
                  <i className="fa-solid fa-arrow-up-right"></i>
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
